<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <div class="slider-wrapper">
    <transition name="fade">
      <div class="top-swiper placeholder" v-if="!featured">
        <slide
          background-image="loading"
          title="loading"
          subtitle="loading"
          :loading="true"
        ></slide>
      </div>
      <swiper
        v-if="featured"
        ref="mySwiper"
        class="top-swiper"
        :options="swiperOptions"
      >
        <slide
          v-for="item in featured"
          :key="`slide_${item.id}`"
          :link="item.slug"
          :background-image="item.image"
          :title="item.title"
          :subtitle="item.subtitle"
          :content="item.excerpt"
        ></slide>
        <div class="swipe-prev" slot="button-prev">
          <button class="button is-rounded icon-button">
            <left-arrow class="icon arrow" @click="swipePrev" />
          </button>
        </div>
        <div class="swipe-next" slot="button-next">
          <button class="button is-rounded icon-button">
            <right-arrow class="icon arrow" @click="swipeNext" />
          </button>
        </div>
      </swiper>
    </transition>
    <div class="slider-pagination-wrapper">
      <div class="slider-pagination-content">
        <div
          :key="`slide_${idx}`"
          class="pagination-dot"
          @click="setSlide(idx)"
          :class="{ active: idx === activeSlideIndex }"
          v-for="(slide, idx) in Array(slidesCount)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftArrow from "@images/arrow_back_ios-24px.svg";
import RightArrow from "@images/arrow_forward_ios-24px.svg";
import Slide from "./slide";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      activeSlideIndex: 0,
      slidesCount: 0
    };
  },
  components: {
    LeftArrow,
    RightArrow,
    Slide
  },
  methods: {
    swipeNext() {
      this.swiper.slideNext(500);
    },
    swipePrev() {
      this.swiper.slidePrev(500);
    },
    setSlide(idx) {
      this.swiper.slideTo(idx + 1, 500);
    },
    onSlideChanged() {
      this.activeSlideIndex = this.swiper.realIndex;
    },
    ...mapActions({ loadFeatured: "featured/load" })
  },
  computed: {
    ...mapGetters({ featured: "featured/featured" }),
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    swiperOptions() {
      return {
        slidesPerView: 1,
        // autoplay: {
        //   delay: 3000
        // },
        // autoHeight: true,
        spaceBetween: 0,
        allowTouchMove: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      };
    }
  },
  async mounted() {
    await this.loadFeatured();
    this.swiper.on("slideChange", this.onSlideChanged);
    this.slidesCount = this.swiper.slides.length - 2;
  },
  destroyed() {
    this.swiper.off("slideChange", this.onSlideChanged);
  }
};
</script>

<style lang="scss">
@import "./slider-unscoped";
</style>
